import { SelectedFilter } from "../../../components/Filters/types";
import { fetchApi } from "../../../lib/fetchApi";
import { saveCSV } from "../../../services/api/csvManagmentService";
import { SurveyHistoryFields, SurveysHistoryCSV } from "../types";
import { getHistoryCsvColumns } from "./getHistoryCsvColumns";

type HistoryResponse = {
    surveyHistoryFields: SurveyHistoryFields[];
};

const EXPORT_PAGE_SIZE = 10000;

export const exportHistoryCsv = async (selectedFilters: SelectedFilter[]): Promise<void> => {
    const hasAlert = selectedFilters.some((filter) => filter.name === "AlertAI");
    const historyFilters = selectedFilters.filter((filter) => filter.name !== "AlertAI");

    const historyResponse = await fetchApi.post("/surveys/history", {
        selectedFilters: historyFilters,
        pageNumber: 1,
        pageSize: EXPORT_PAGE_SIZE,
        orderByField: "",
        orderDirection: "asc",
        hasAlert,
    }) as HistoryResponse;

    const csvColumns = await getHistoryCsvColumns();

    const body: SurveysHistoryCSV = {
        surveyHistoryFields: historyResponse?.surveyHistoryFields ?? [],
        itemsHeader: csvColumns,
        selectedFilters: historyFilters,
    };

    await saveCSV(body);
};
